module.exports = __webpack_public_path__ + "img/project15_3.jpeg.182c5181.webp";